import { useCallback } from 'react';
import useEntityFormContext from './internal/useEntityFormContext';
export default function useUpdateValue() {
    const { setFieldValue } = useEntityFormContext();
    return useCallback(
    // eslint-disable-next-line no-magic-numbers
    (field, value, shouldValidate) => {
        setFieldValue(field, value, shouldValidate);
    }, [setFieldValue]);
}
